export class BookingCustomer {
  constructor() {
    this.id;
    this.bookingCustomerId;
    this.name;
    this.phoneNumber;
    this.email;
    this.deleted;
    this.type;
  }

  isValid() {
    const nameNotEmpty =
      !!this.name && !!this.name.trim();
    const emailNotEmpty =
      !!this.email && !!this.email.trim();
    const phoneNumberNotEmpty =
      !!this.phoneNumber &&
      !!this.phoneNumber.trim();
    return (
      ((nameNotEmpty && emailNotEmpty && phoneNumberNotEmpty) ||
        (!nameNotEmpty && !emailNotEmpty && !phoneNumberNotEmpty))
    );
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new BookingCustomer(), json);
  }
}
